import React from 'react';
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; { new Date().getFullYear() } - Thierry Brouet - <a href="https://thierry-brouet.fr">https://thierry-brouet.fr</a></p>
        </footer>
    );
};

export default Footer;
